import React, { useState } from 'react';
import logoWhite from '../assets/LinkedIn-Local-Cameroon-Logo-white.png';

const leftLinks = [
  { label: 'Agenda', href: '#schedule' },
  { label: 'Terms & Conditions', href: '#!' },
  { label: 'Speakers', href: '#speakers' },
  { label: 'Privacy Policy', href: '#!' },
  { label: 'Register', href: '#tickets' },
  { label: 'Cookie Policy', href: '#!' },
  { label: 'Venue', href: '#venue' },
];

const socialIcons = ['f', 'in', 'ig', 'yt'];

export default function Footer() {
  const [email, setEmail] = useState('');

  return (
    <div className="container" style={{ paddingBottom: '40px' }}>
      <div className="footer">
        <div className="footer__left">
          <img src={logoWhite} alt="LinkedIn Local Cameroon" style={{ height: '44px', width: 'auto', display: 'block', marginBottom: '24px' }} />
          <div className="footer__links-grid">
            {leftLinks.map((l) => (
              <li key={l.label} style={{ listStyle: 'none', marginBottom: '10px' }}>
                <a href={l.href} className="footer__links" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)' }}>
                  {l.label}
                </a>
              </li>
            ))}
          </div>
          <div style={{ marginTop: '24px', fontSize: '11px', color: 'rgba(255,255,255,0.25)' }}>
            FAQ
          </div>
        </div>

        <div className="footer__right">
          <div className="footer__newsletter-title">STAY UPDATED</div>
          <div className="footer__newsletter-desc">
            Subscribe for LLC 2026 updates, early bird alerts, and exclusive content.
          </div>
          <input
            className="footer__email-input"
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button className="btn-stay-updated" onClick={() => setEmail('')}>
            Stay updated
          </button>
          <div className="footer__follow-title">FOLLOW US</div>
          <div className="footer__social">
            {socialIcons.map((s) => (
              <a key={s} href="#!" className="footer__social-icon">{s}</a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        &copy; 2026 LinkedIn Local Cameroon. Rise Locally, Lead Globally.
      </div>
    </div>
  );
}
